module.exports = __webpack_public_path__ + "static/media/18.b97f94d3.jpg";